import classNames from 'classnames';
import style from './tooltip-comp.module.scss';

export type TooltipPosition = 'top' | 'left' | 'right' | 'bottom';

export type Props = {
  children?: React.ReactNode;
  content: React.ReactNode;
  hookStyle?: any;
  hookClassName?: string;
  position?: TooltipPosition;
  showTooltip: boolean;
  textStyle?: any;
  theme?: 'error' | 'blue';
  containerStyle?: string;
};

const TooltipComp = (props: Props) => {
  const {
    children,
    content,
    position = 'top',
    hookStyle,
    hookClassName,
    showTooltip,
    theme,
    containerStyle,
  } = props;

  if (!showTooltip) return <span>{children}</span>;

  return (
    <div
      className={classNames(
        style.container,
        containerStyle && style[containerStyle],
      )}
    >
      <div
        style={hookStyle}
        className={classNames(
          style.hook,
          style[`hook--${position}`],
          hookClassName && style[hookClassName],
        )}
      >
        <div
          style={props.textStyle}
          className={classNames(style.text, theme && style[`text--${theme}`])}
        >
          {content}
          <div
            className={classNames(
              style.arrow,
              style[`arrow--${position}`],
              theme && style[`arrow--${theme}`],
            )}
          />
        </div>
      </div>
      {children}
    </div>
  );
};

TooltipComp.displayName = 'TooltipComp';
export default TooltipComp;
